import rehypeStringify from "rehype-stringify";
import remarkGfm from "remark-gfm";
import remarkParse from "remark-parse";
import remarkRehype from "remark-rehype";
import { unified } from "unified";

const markdownToHtml = (markdown: string) => {
  try {
    const processor = unified()
      .use(remarkParse) // Parse markdown
      .use(remarkGfm) // Support tables, strikethrough, task lists, etc.
      .use(remarkRehype) // Convert markdown AST to HTML AST
      .use(rehypeStringify); // Convert HTML AST to string

    const result = processor.processSync(markdown);
    return String(result);
  } catch (error) {
    console.error("Error converting markdown to html", error);
    return markdown;
  }
};

export default markdownToHtml;
